import { render, staticRenderFns } from "./destinations.vue?vue&type=template&id=6063a376&scoped=true"
import script from "./destinations.vue?vue&type=script&lang=js"
export * from "./destinations.vue?vue&type=script&lang=js"
import style0 from "./destinations.vue?vue&type=style&index=0&id=6063a376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6063a376",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default})
